// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12-CI","col":"styles_col__2pgux"};